var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "government-line 1",
    clipPath: "url(#clip0_13098_11826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6668 5H19.1668V6.66667H18.3335V15.8333H19.1668V17.5H0.833496V15.8333H1.66683V6.66667H0.833496V5H3.3335V3.33333C3.3335 3.11232 3.42129 2.90036 3.57757 2.74408C3.73385 2.5878 3.94582 2.5 4.16683 2.5H15.8335C16.0545 2.5 16.2665 2.5878 16.4228 2.74408C16.579 2.90036 16.6668 3.11232 16.6668 3.33333V5ZM16.6668 6.66667H3.3335V15.8333H5.8335V10H7.50016V15.8333H9.16683V10H10.8335V15.8333H12.5002V10H14.1668V15.8333H16.6668V6.66667ZM5.00016 4.16667V5H15.0002V4.16667H5.00016Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13098_11826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/cinema.d7498603df3999bf4cf5d51fdc4f373b.svg";
export { ForwardRef as ReactComponent };